import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@shared/contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/staff/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
